import * as React from 'react';
import renderIcon from 'helpers/renderIcon';

interface IBaseProps {
	imageUrl: string;
	editFunction?: any;
	hasPicture?: boolean;
	avatar?: any;
	small?: boolean;
	fromShop?: boolean;
	icon?: ReturnType<typeof renderIcon>;
}

const BaseCoverPicture = (props: IBaseProps) => {
	const { editFunction, hasPicture, imageUrl, small, fromShop, icon } = props;
	let image = null;

	if (imageUrl) {
		image = (
			<div className={`profile-photo ${hasPicture ? 'full' : ''}`} style={{ backgroundImage: `url(${imageUrl})` }} />
		);
	} else if (icon) {
		image = icon;
	} else {
		image = fromShop ? renderIcon('pfp_salon') : renderIcon('pfp_default');
	}

	return (
		<div className={`profile-photo-container ${small ? 'small' : ''} d-flex align-items-center justify-content-center`}>
			{image ? image : renderIcon('pfp_default')}
			{editFunction ? (
				<div className="changeIcon pointer" onClick={editFunction}>
					{renderIcon('edit', 32, 32)}
				</div>
			) : null}
		</div>
	);
};

export const CoverPicture = (props: IBaseProps) => <BaseCoverPicture {...props} avatar={null} />;
